export default "/assets/images/app-notification-video.f2866cb0dd0fa5bd.mp4";